import "./App.css";
import Jivini from "./modules/jivini";
import Index from "./routes";

function App() {
  return (
    <div className="App">
      <Index />
    </div>
  );
}

export default App;
